import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button, Card } from '../components';
import Footer from '../components/Footer';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

export const PendingApprovalPage: React.FC = () => {
  const { agentData, logout, setGlobalNotification } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (agentData?.isApproved) {
      navigate('/dashboard');
    }
  }, [agentData, navigate]);

  const handleLogout = async () => {
    await logout();
    setGlobalNotification({ message: t('success_logout'), type: 'success' });
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col bg-neutral-100">
      <div className="fixed top-4 right-4 z-50">
        <LanguageSwitcher />
      </div>
      <div className="flex-1 flex items-center justify-center">
        <Card className="w-full max-w-md text-center">
          <div className="p-8">
            <img src="/logo.png" alt="HomeMe Portaal Logo" className="h-20 w-auto mx-auto mb-6 rounded-[15px]" />
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-homeme mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">{t('pending_approval_title', 'Account in behandeling')}</h2>
            <p className="text-neutral-600 mb-6">
              {t('pending_approval_message', 'Bedankt voor uw registratie! Uw account wordt momenteel beoordeeld door een beheerder. U ontvangt bericht zodra uw account is goedgekeurd.')}
            </p>
            <Button onClick={handleLogout} variant="secondary">{t('logout', 'Uitloggen')}</Button>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
};
